import { useContext, useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { Box, Button, Paper, TextField } from "@mui/material";
import { MainContext, MainContextState } from "../../context/MainContext";
import { useNotification } from "../../hooks/useNotification";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { MAIN_RULES } from "../../constants/formRules";
import { EmployeeDataEdit } from "../../types/api/employee";
import { editEmployee } from "../../api/employeeAPI";
import CustomSnackbar from "../UI/CustomSnackbar";
import Modal from "../UI/Modal/Modal";

const PersonalData = () => {
    const [load, setLoad] = useState(false);
    const { user, setUser } = useContext<Partial<MainContextState>>(MainContext);
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();
    const [input, setInput] = useState<any>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const closeModal = () => {
        setShowModal(false);
    };

    const { setError, control, handleSubmit, reset } = useForm<EmployeeDataEdit>({
        values: {
            name: input?.name ?? "",
            surname: input?.surname ?? "",
            lastname: input?.lastname ?? "",
            phone: input?.phone ?? undefined,
            email: input?.email ?? "",
            employee_type: input?.employee_data?.employee_type,
            from: input?.employee_data?.from?.slice(0, 10).replace(/-/g, "/"),
            to: input?.employee_data?.to?.slice(0, 10).replace(/-/g, "/"),
            work_position: input?.employee_data?.work_position || [],
            work_info: input?.employee_data?.work_info || [],
            photos: [input?.photo],
        },
    });

    const edit: SubmitHandler<EmployeeDataEdit> = (data: any) => {
        setLoad(true);
        editEmployee(
            input?.employee_data?.center?.id,
            input?.id,
            data,
            ({ data }) => {
                setNotification({
                    severity: "success",
                    message: "Данные изменены успешно",
                });
                if (setUser) {
                    setUser({
                        ...data,
                        employee_data: { ...data.employee_data, center: user?.employee_data?.center },
                    });
                }
                setOpenSnackbar(true);
                setLoad(false);
                closeModal();
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
                setOpenSnackbar(true);
                if (err?.errors) {
                    Object.keys(err.errors).forEach((fieldName: any) => {
                        setError(fieldName, {
                            type: "custom",
                            message: err.errors[fieldName][0],
                        });
                    });
                }
            },
        );
        reset();
    };
    useEffect(() => {
        setLoad(true);
        setInput(user);
        setTimeout(() => {
            setLoad(false);
        }, 500);
    }, [user]);

    return (
        <div className={"container"}>
            <div className={"pageHeader"}>Личный кабинет</div>
            {!load && (
                <Paper
                    sx={{
                        padding: "20px",
                        width: "100%",
                    }}>
                    <Box
                        component="form"
                        sx={{
                            "& .MuiTextField-root": { my: 1 },
                        }}
                        noValidate
                        autoComplete="off">
                        <Controller
                            defaultValue={""}
                            name="surname"
                            control={control}
                            rules={{
                                required: true,
                                maxLength: {
                                    value: 120,
                                    message: "Максимальная длина 120 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size={"small"}
                                    fullWidth
                                    label={"Фамилия"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="name"
                            control={control}
                            rules={{
                                required: true,
                                maxLength: {
                                    value: 120,
                                    message: "Максимальная длина 120 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size={"small"}
                                    fullWidth
                                    label={"Имя"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="lastname"
                            control={control}
                            rules={{
                                maxLength: {
                                    value: 120,
                                    message: "Максимальная длина 120 символов",
                                },
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size={"small"}
                                    fullWidth
                                    label={"Отчество"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="phone"
                            control={control}
                            rules={{
                                required: true,
                                pattern: MAIN_RULES.phone,
                            }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    label={"Телефон"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="email"
                            control={control}
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    label={"Почта"}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="from"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value, ...field }, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    label="Дата начала"
                                    onChange={(e: any) => {
                                        onChange(e.target.value.replace(/-/g, "/"));
                                    }}
                                    value={value?.replace(/\//g, "-")}
                                    autoComplete="off"
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            defaultValue={""}
                            name="to"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value, ...field }, fieldState }) => (
                                <TextField
                                    {...field}
                                    size={"small"}
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    label="Дата окончания сотрудничества"
                                    onChange={(e: any) => {
                                        onChange(e.target.value.replace(/-/g, "/"));
                                    }}
                                    value={value?.replace(/\//g, "-")}
                                    autoComplete="off"
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Box>
                </Paper>
            )}
            <div className={"posBR"}>
                <Button variant="outlined" onClick={() => setShowModal(true)}>
                    Редактировать
                </Button>
            </div>
            <Modal
                open={showModal}
                title={"Редактирование личного кабинета"}
                onClose={() => {
                    closeModal();
                }}
                onSubmit={handleSubmit(edit)}>
                <div>Вы уверены, что хотите редактировать(обновить) данные?</div>
            </Modal>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={load} />
        </div>
    );
};

export default PersonalData;
